/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DiscordConnectionIntegration
 */
export interface DiscordConnectionIntegration {
    /**
     * 
     * @type {string}
     * @memberof DiscordConnectionIntegration
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscordConnectionIntegration
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscordConnectionIntegration
     */
    type?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DiscordConnectionIntegration
     */
    enabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DiscordConnectionIntegration
     */
    syncing?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DiscordConnectionIntegration
     */
    role_id?: string;
    /**
     * 
     * @type {number}
     * @memberof DiscordConnectionIntegration
     */
    subscriber_count?: number;
}

/**
 * Check if a given object implements the DiscordConnectionIntegration interface.
 */
export function instanceOfDiscordConnectionIntegration(value: object): value is DiscordConnectionIntegration {
    return true;
}

export function DiscordConnectionIntegrationFromJSON(json: any): DiscordConnectionIntegration {
    return DiscordConnectionIntegrationFromJSONTyped(json, false);
}

export function DiscordConnectionIntegrationFromJSONTyped(json: any, ignoreDiscriminator: boolean): DiscordConnectionIntegration {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'type': json['type'] == null ? undefined : json['type'],
        'enabled': json['enabled'] == null ? undefined : json['enabled'],
        'syncing': json['syncing'] == null ? undefined : json['syncing'],
        'role_id': json['role_id'] == null ? undefined : json['role_id'],
        'subscriber_count': json['subscriber_count'] == null ? undefined : json['subscriber_count'],
    };
}

export function DiscordConnectionIntegrationToJSON(json: any): DiscordConnectionIntegration {
    return DiscordConnectionIntegrationToJSONTyped(json, false);
}

export function DiscordConnectionIntegrationToJSONTyped(value?: DiscordConnectionIntegration | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'type': value['type'],
        'enabled': value['enabled'],
        'syncing': value['syncing'],
        'role_id': value['role_id'],
        'subscriber_count': value['subscriber_count'],
    };
}

